import React, { useState } from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";
import { DeleteKeys, updateWidgetBanner } from "../../../../../../actions/appsMoreAction";
import { TOAST_ERROR, TOAST_SUCCESS, resturctureCloudPath } from "../../../../../../utils";
import { useDispatch } from "react-redux";
import { refreshThemes } from "../../../../../../actions/firstRunAction";
import DesignBanner from "./DesignBanner";
import CheckBoxField from "../../../Feeds/AddFeeds/Elements/CheckboxField";
import { CLOUD_URL } from "../../../../../../actions/api";
import { FontAwesomeIcon } from "../../../../../CommonComponents/AssetsHelper";


const Banner = (props) => {

  const { themeBanner, banner, fonts, wallData, onUpload, bannerImageUpdate, sizeError, onUppyModal, logImageUpdate, customBannerUpdate, bannerPrevius } = props;
 
  const ugcSetting = wallData.wall.UgcSettings;
  const { CustomBannerImage, BannerImage, LogoImage, banner_position, subTitle, subTitle_font_color, title, title_font_color, background_color_two, background_color, status, social_icon_status, social_icon_size, social_icon_color, social_icon_color_status, title_font_size, subTitle_font_size, transparent, social_icons, title_css_font, title_font_varient, subtitle_css_font, subtitle_font_varient, bannerType } = banner;

  const [banerEnableStatus, setbanerEnableStatus] = useState(BannerImage.status || status ? 1 : 0);
  const [customBannerStatus, setcustomBannerStatus] = useState(BannerImage.status ? true : false);
  const [loading, setLoading] = useState(false)
  const [bannerRemove, setBannerRemove] = useState(0);


  const [titleFontStyle, setTitleFontStyle] = useState( title_css_font || "" );
  const [titleFontVar, setTitleFontVar] = useState( title_font_varient || "" );
  const [subtitleFontStyle, setSubtitleFontStyle] = useState( subtitle_css_font || "" );
  const [subtitleFontVar, setSubtitleFontVar] = useState( subtitle_font_varient || "" );

  const [socialIcons, setSocialIcons] = useState(
    social_icons
      ? {
        fb: social_icons.includes("1"),
        twitter:
          social_icons.includes("2"),
        insta:
          social_icons.includes("3"),
      }
      : bannerType ? {
        fb: true,
        twitter: true,
        insta: true,
      } : ""
  );

  const socialIconStatus = (socialIcons) => {
    setSocialIcons(socialIcons)
    themeBanner({ social_icons: `${socialIcons.fb ? socialIcons.twitter || socialIcons.insta ? "1," : "1" : ""}${socialIcons.twitter ? socialIcons.insta ? "2," : "2" : ""}${socialIcons.insta ? "3" : ""}` })
  }


  const selectbannerType = (data) => {
    setcustomBannerStatus(!data ? true : false);
  }

  const bannerStatus = (data, status) => {
    setbanerEnableStatus(data);
    if (data) {
      themeBanner(BannerImage ? { status: status, bannerUpdate: 1, BannerImage: { ...BannerImage, status: !status ? data : 0 } } : { status: status, bannerUpdate: 1 });
    } else {
      themeBanner(BannerImage ? { status: 0, bannerUpdate: 0, BannerImage: { ...BannerImage, status: BannerImage.newName ? data : 0 } } : { status: 0, bannerUpdate: 0 });
    }
  }



  // DESIGN BANNER STATE END 
  const dispatch = useDispatch();

  const onApplyBanner = () => {

    const bannerObjImage = {
      ownerId: localStorage.getItem('ownerId'),
      collaboratorsRoleWalls: "",
      wallId: localStorage.getItem('wallId'),
      CustomBannerId: "",
      bannerId: "",
      bannerType: banner.bannerType,
      bannerImgBack: "",
      logoImage: LogoImage ? LogoImage.newName : "",
      // logoImage: LogoImage ? resturctureCloudPath(LogoImage.newName, `https://cloud.taggbox.com/${LogoImage.path}`) : "",
      transparent: transparent,
      background_color: background_color,
      background_color_two: background_color_two,
      defaultBgImage: customBannerStatus ? "" : "1",
      backgroundImage: CustomBannerImage ? resturctureCloudPath(CustomBannerImage.newName, `${CLOUD_URL}${CustomBannerImage.path}`) : "",
      bannerImage: BannerImage && BannerImage?.newName ? resturctureCloudPath(BannerImage.newName, `${CLOUD_URL}${BannerImage.path}`) : "",
      backgroundImageValue: BannerImage && BannerImage?.newName ? "0" : "1",
      subTitle: subTitle,
      subTitle_font_color: subTitle_font_color,
      subtitle_link_font: subtitleFontStyle ? subtitleFontStyle.replace(/\s+/g, '+') : 'None',
      subtitle_css_font: subtitleFontStyle ? subtitleFontStyle : 'None',
      subtitle_font_varient: subtitleFontVar,
      subTitle_font_size: subTitle_font_size,
      title: title,
      title_font_color: title_font_color,
      title_link_font: titleFontStyle ? titleFontStyle.replace(/\s+/g, '+') : null,
      title_css_font: titleFontStyle,
      title_font_varient: titleFontVar,
      title_font_size: title_font_size,
      socialcheckOnOff: social_icon_status,
      socialcheckon: social_icons,
      socialIconSize: social_icon_size,
      socialIconColorStatus: social_icon_color_status,
      socialIconColor: social_icon_color,
      facebook_url: banner.facebook_url,
      twitter_url: banner.twitter_url,
      instagram_url: banner.instagram_url,
      bannerHeight: banner.banner_height,
      bannerImagePosition: !customBannerStatus ? banner_position : "",
      bannerRemove: customBannerStatus ? BannerImage && BannerImage.newName ? 0 : bannerRemove : 0,
      bannerImageStatus: customBannerStatus ? banerEnableStatus && BannerImage && BannerImage.status ? true : false : false,
      customBannerStatus: status && banerEnableStatus ? true : false,
      logoImageValue: customBannerStatus ? "0" : "1",
    };


    setLoading(true);
    updateWidgetBanner(bannerObjImage).then((res) => {
      const { data } = res
      if (data.status) {
        setTimeout(() => {

          const { logoImageResponse, bgImageResponse, customBanner } = data;
          const custombanner = customBanner ? customBanner : bannerObjImage.bannerImage;
          const logoImg = logoImageResponse && Object.keys(logoImageResponse).length > 0 ? logoImageResponse.newName : bannerObjImage.logoImage;
          const bnImg = bgImageResponse && Object.keys(bgImageResponse).length > 0 ? bgImageResponse.newName : bannerObjImage.bannerImage;

          props.updateImages('', { bnImg: bnImg, logoIg: logoImg, custombanner: custombanner, customBannerStatus: customBannerStatus ? 1 : 0, customBgStatus: !customBannerStatus ? 1 : 0 });

          DeleteKeys()
          TOAST_SUCCESS("Banner update successfully.")
          setLoading(false)
          themeBanner({ bannerChange: 1 })
          props.activeSetting(0);
          dispatch(refreshThemes());
        }, 2000);
      }
      else TOAST_ERROR(data.message)
      setLoading(false)
    })
  }

  const applyChanges = (status) => {
    const { showDiscardPop } = props;
    showDiscardPop(onApplyBanner, 'banner', status);
  }
  return (
    <div className="">
      <div className="bannerForm overflow-list">
        <div className="pb-3 f-between">
          <label className="card-label font-weight-bolder text-dark mb-0">Banner</label>
          <OverlayTrigger placement="top" overlay={<Tooltip>Help</Tooltip>}>
            <a className="lity_lightbox ms-2" href="https://vimeo.com/545383485/ef1a12655f" data-lity=""> <FontAwesomeIcon type={'regular'} icon={'circle-question'} iconClass={'text-gray-500'} /> </a>
          </OverlayTrigger>
        </div>

        <div id="collapseFive1" className="form-group">
          <div className="backgroundForm">
            <div className="d-flex justify-content-between" id="custbannerStatusBtn">
              <div className="me-2 d-flex">
                <label className="d-flex align-items-center mb-0">
                  <span className=" me-1">Enable Banner</span>
                  <OverlayTrigger placement="right" overlay={<Tooltip>Enable this to display a banner.</Tooltip>}>
                    <span><FontAwesomeIcon type={'solid'} icon={'circle-info'} iconClass={'text-gray-500 fs-6'} /></span>
                  </OverlayTrigger>
                </label>
              </div>
              <div className="toggleOnBut pt-1">
                <input type="hidden" name="data[CustomBanner][customBannerStatus]" id="wallcustomBannerStatus_" value="0" />
                <span className="switch">
                  <label>
                    <CheckBoxField isChecked={banerEnableStatus} onChangeHandler={(e) => { bannerStatus(e.target.checked ? 1 : 0, customBannerStatus ? 0 : 1,) }} name={`CustomBanner`} id={`CustomBanner`} text={0} />
                  </label>
                </span>
              </div>
            </div>
          </div>
        </div>


        <div id="bannerOption" className="bannerFormButton">
          <div className="form-group">
            <button type="button" className={`btn btn-outline-secondary bg-transparent above-margin-tab mb-3 w-100 text-start position-relative btn-radio px-2  ${customBannerStatus ? 'active-banner' : ''}`} onClick={() => { selectbannerType(0); themeBanner({ BannerImage: BannerImage ? { ...BannerImage.status = banerEnableStatus ? 1 : 0, ...BannerImage } : "", status: 0, customBannerStatus: false }) }}> Custom Banner </button>
            <button type="button" className={`btn btn-outline-secondary bg-transparent above-margin-tab mb-3 w-100 text-start position-relative btn-radio px-2 ${!customBannerStatus ? 'active-banner' : ''}`} onClick={() => { selectbannerType(1); themeBanner({ BannerImage: BannerImage ? { ...BannerImage.status = 0, ...BannerImage } : "", status: banerEnableStatus ? 1 : 0, customBannerStatus: true }) }}> Choose From Templates</button>

          </div>
        </div>



        {customBannerStatus ? (

          <div>
            {banner && banner.BannerImage.newName ?
              <div className="p-0 ">
                <div className="image-input fileinput fileinput-new addProUploder addbgUpload uppy_upload ms-0" data-provides="fileinput" style={{ display: "flex" }}>
                  <div id="BannerBackgroundImageUpload" style={{ backgroundImage: `url(${banner.BannerImage.newName})` }} className="BannerBackgroundImageUpload align-content-center flex-wrap justify-content-center mb-0 border-bottom-0" data-trigger="fileinput" >
                    <input type="hidden" id="BbannerBack" />
                    <button type="button" id="removeBgBanner" className="removeBgBanner btn btn-xs btn-icon btn-circle btn-white btn-shadow" onClick={() => { onUpload(false, ''); setBannerRemove(1); bannerImageUpdate('') }} > <i className="fa fa-close"></i> </button>
                  </div>
                  <div className="drop-box" id="kt_uppy_4">
                    <div className="uppy-dashboard"></div>
                    <div className="uppy-progress"></div>
                  </div>
                </div>
              </div>
              :
              <>
                <div className="attach-file border p-1 uppy-uploader">
                  <Button variant="outline-secondary" onClick={() => onUpload(true, '')} className="f-center w-100" style={{ backgroundImage: `url(https://img.freepik.com/free-vector/hand-painted-watercolor-pastel-sky-background_23-2148902771.jpg?size=626&ext=jpg&ga=GA1.1.2116175301.1701388800&semt=sph)`, backgroundSize: 'cover' }}>
                    <FontAwesomeIcon type={'solid'} icon={'arrow-up-from-bracket'} iconClass={'fs-5 me-2'} />
                    Upload Banner</Button>
                </div>

                <div className="mt-4 p-0">
                  <div className="aspectRatios">
                    Recommended size: 1920 x 150 px OR 1920 x 200 px | Supported
                    Formats: .png or .jpg | Maximum Image Size: 5 Mb
                  </div>

                  {sizeError && <div className="mt-3 alert alert-danger">{sizeError}</div>}
                </div>
              </>
            }
          </div>

        ) :

          fonts && fonts.length ?
            <DesignBanner socialIconStatus={socialIconStatus} bannerPrevius={bannerPrevius} socialIcons={socialIcons} customBannerUpdate={customBannerUpdate} setSocialIcons={setSocialIcons} logImageUpdate={logImageUpdate} setSubtitleFontVar={setSubtitleFontVar} setSubtitleFontStyle={setSubtitleFontStyle} setTitleFontVar={setTitleFontVar} setTitleFontStyle={setTitleFontStyle} banner={banner} themeBanner={themeBanner} activeSetting={props.activeSetting} ugcSetting={ugcSetting} fonts={fonts} onUppyModal={onUppyModal} /> : null
        }

      </div>

      <div className="form-actions px-3 pt-3">
        <div className="card-toolbar f-center">
          <Button variant="secondary" className="me-2 w-50" onClick={() => applyChanges(0)}>Back</Button>
          <Button variant="dark" type="submit" id="bannerApplyBtn" disabled={loading} className={`${loading ? 'ladda-button spinner spinner-white spinner-right disabled ' : ''} w-50`}
            onClick={() => applyChanges(1)}>Save</Button>
        </div>
      </div>

    </div>
  );
};

export default Banner;
